import { Injectable } from "@angular/core";
import { HttpClient } from "../shared/wrappers/HttpClient";
import { ToastsManager } from "ng2-toastr";
import { ErrorHandlerProvider } from "../shared/providers/errorHandler.provider";
import { KenobyConsultant } from '../models/KenobyConsultant.model';

@Injectable()
export class kenobyConsultantService {
    constructor(private httpClient: HttpClient,
                public toastr:ToastsManager,
                private errorHandler: ErrorHandlerProvider) { }

    endPoint: String = "/kenobyConsultants";

    async searchConsultants(kenobyConsultantSearch): Promise<KenobyConsultant[]> {
        var queryString = "?";

        if (kenobyConsultantSearch.name){
            queryString += `name=${kenobyConsultantSearch.name}`;
        }
        if (kenobyConsultantSearch.email){
            queryString += `email=${kenobyConsultantSearch.email}`;
        }
        if (kenobyConsultantSearch.phone){
            queryString += `phone=${kenobyConsultantSearch.phone}`;
        }
        if (kenobyConsultantSearch.opportunity){
            queryString += `code=${kenobyConsultantSearch.opportunity}`;
        }
        if (kenobyConsultantSearch.division !== null && kenobyConsultantSearch.division.length > 0) {
            for (var i = 0; i < kenobyConsultantSearch.division.length; i++) {
                if (queryString !== "") queryString += "&";

                queryString += `division=${kenobyConsultantSearch.division[i]}`;
            }
        }
        if (kenobyConsultantSearch.status !== null && kenobyConsultantSearch.status.length > 0) {
            for (var i = 0; i < kenobyConsultantSearch.status.length; i++) {
                if (queryString !== "") queryString += "&";

                queryString += `status=${kenobyConsultantSearch.status[i]}`;
            }
        }

        let response = await this.httpClient.get(`${this.endPoint}`, queryString);

        const consultants = response.consultants;
        kenobyConsultantSearch.totalItems = consultants.length;

        return consultants.map(consultant => {
            return new KenobyConsultant(consultant);
        });
    }

    async getConsultantKenoby(id: string) {
        return await this.httpClient.get(`${this.endPoint}/${id}`);
    }

    async updateConsultantKenoby(id: string, data: any) {
        return await this.httpClient.update(this.endPoint, id, data);
    }

    async removeKenoby(id: string) {
        return await this.httpClient.delete(`${this.endPoint}`, id);
    }

}



// WEBPACK FOOTER //
// ./src/app/services/kenobyConsultants.service.ts